<template>
    <div
        :class="{ '-no-background': noBackground, '-error': hasError }"
        class="select-wrap"
        @click="clickHandler"
    >
        <label class="label">{{ label }}</label>
        <div class="selector" :class="{ '-disabled': disabled }">
            <RightClickMenu
                style="max-width: 100%"
                :block="true"
                :disabled="disabled"
                :menuContent="checkedOptions"
                @action="actionEmited"
            >
                <div class="select-body">
                    <div
                        class="value"
                        v-if="value != null || value != undefined"
                    >
                        {{ showDisplay(value) }}
                    </div>
                    <div
                        class="value"
                        v-if="value == null || value == undefined"
                    >
                        {{ placeholder }}
                    </div>
                </div>
            </RightClickMenu>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: String,
        value: [String, Number, Boolean],
        options: Array,
        noBackground: Boolean,
        placeholder: String,
        disabled: Boolean,
        errors: Object,
        name: String,
        translate: Boolean
    },
    data() {
        return {}
    },
    computed: {
        hasError() {
            if (!this.errors || !this.name) {
                return false
            } else {
                return this.errors.has(this.name) && !this.noBackground
            }
        },
        checkedOptions() {
            let options = []
            this.options.forEach(option => {
                if (!option.notAvailable) {
                    options.push(option)
                }
            })
            return options
        }
    },
    methods: {
        clickHandler() {
            if (this.name) {
                this.errors.clear(this.name)
            }
        },
        showDisplay(value) {
            let index = this.options.findIndex(option => {
                return option.event == value
            })
            if (index == -1) {
                if (this.placeholder) {
                    return this.placeholder
                }
            } else {
                return this.translate
                    ? this.$t(this.options[index].display)
                    : this.options[index].display
            }
        },
        actionEmited(action) {
            this.$emit('input', action)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.select-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    max-width: 100%;

    cursor: default;
    transition: all 0.1s ease;

    &:not(:first-of-type) {
        margin-top: 1rem;
    }

    &.-error {
        border: 2px solid $accent-red;
    }

    &.-no-background {
        margin-bottom: 0px;
        background: transparent;
        border: none;
    }
}
.selector {
    display: flex;
    min-width: 5rem;
    width: 100%;

    &.-disabled {
        pointer-events: none;
    }
}
.select-body {
    min-width: 5rem;
    padding: 0.45rem 0.5rem;
    margin: 0.4rem;
    max-width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    color: #fff;
    background: $accent-blue;
    font-family: $input-family;
    border-radius: $input-radius;
    border: none;
    cursor: pointer;

    transition: $ease;

    &:hover {
        background: darken($accent-blue, 10%);
    }
}
.value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    padding-right: 5px;
    box-sizing: border-box;
    user-select: none;
}
.arrow {
    height: 0.5rem;
    margin-top: 5px;
    margin-left: 3px;
}
</style>
